module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/bft-ca3ba9f273e069902ac86ae4e721d71f.png";